import { Box, CircularProgress, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
// import Stack from "@mui/material/Stack";

import componentStyles from "../../assets/styles/containers/issue_detail";

const useStyles = makeStyles(componentStyles);

const CustomBox = (props) => {
  const { children, loading, errors } = props;
  const classes = useStyles();

  return (
    <>
      {loading !== false ? (
        // ローディング中の表示
        <Box className={classes.customBoxWrapper}>
          <Box className={classes.loadingWrapper}>
            <CircularProgress />
          </Box>
        </Box>
      ) : Object.keys(errors).length !== 0 ? (
        // エラー表示
        <Box className={classes.customBoxWrapper}>
          {Object.keys(errors).map((key) => {
            return (
              <Alert severity="error">{`${key}: ${errors[key].message}`}</Alert>
            );
          })}
        </Box>
      ) : (
        // コンテンツ表示
        <Box>{children}</Box>
      )}
    </>
  );
};

export default CustomBox;
